<template>
  <div class="index">
    <!-- 
      $route.meta.createActiviti === '1' 
      不显示左侧菜单 顶部菜单
    -->
    <a-layout id="inlet-page">
      <a-layout-sider
        :multiple="false"
        v-model="collapsed"
        :trigger="null"
        collapsible
        width="256"
        style="background: #fff; z-index: 9"
        v-if="$route.meta.createActiviti === '1' ? false : true"
      >
        <div class="logo" @click="goWorkbench">
          <img
            v-if="!collapsed"
            class="logo-img"
            src="./workbench/img/logo6.png"
            alt=""
          />
          <!-- <img
            v-else
            class="logo-img1"
            src="./workbench/img/logo4.png"
            alt=""
          /> -->
        </div>
        <div class="page-menu-cont">
          <SiderBar></SiderBar>
        </div>
      </a-layout-sider>
      <a-layout>
        <a-layout-header
          v-if="$route.meta.createActiviti === '1' ? false : true"
          style="background: #fff; padding: 0"
        >
          <div class="header-nav" ref="aLayout">
            <a-icon
              class="trigger"
              :type="collapsed ? 'menu-unfold' : 'menu-fold'"
              @click="() => (collapsed = !collapsed)"
            />
            <div class="header-right">
              <div class="currentDate">星期{{ getWeek() }} {{ getTime() }}</div>
              <a-icon class="bell" type="bell" @click="gomsg" />
              <div class="userInfoCont" @click="goMIne">
                <img src="./workbench/img/infoLogo.png" alt="" />
                <span class="username">
                  {{ userInfo.fullName }}
                </span>
              </div>
              <div class="header-logout" @click="logout">
                <a-icon class="logout-icon" type="logout" />
                安全退出
              </div>
            </div>
          </div>
        </a-layout-header>
        <a-layout-content style="position: relative">
          <a-breadcrumb
            v-if="$route.meta.createActiviti === '1' ? false : true"
            style="
              margin: 2px 1px 0px 1px;
              height: 54px;
              background: #fff;
              line-height: 54px;
              padding-left: 45px;
            "
          >
            <a-breadcrumb-item>首页</a-breadcrumb-item>
            <a-breadcrumb-item v-if="$route.meta.isMenuOpens">
              {{ $route.meta.isMenuOpens }}
            </a-breadcrumb-item>
            <a-breadcrumb-item>
              {{ $route.meta.title }}
            </a-breadcrumb-item>
          </a-breadcrumb>
          <router-view />
        </a-layout-content>
      </a-layout>
    </a-layout>
  </div>
</template>
<script>
import SiderBar from '@/layout/siderBar.vue'

import { formatDateNoDetails } from '@/assets/js/auth'
import { mapState } from 'vuex'
export default {
  components: {
    SiderBar
  },
  data() {
    return {
      collapsed: false, // 左侧菜单折叠
      selectedOpenKeys: [],
      selectedKeys: []
    }
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.app.userInfo //用户信息
    })
  },
  methods: {
    goWorkbench() {
      // this.goTop()
      if (this.$route.path != '/') {
        this.$router.push('/')
      } else {
        location.reload('/')
      }
    },
    //获取当前年月日
    getTime() {
      let d = new Date()
      return formatDateNoDetails(d)
    },
    //获取当前星期几
    getWeek() {
      let d = new Date()
      let week = d.getDay()
      if (week == 0) {
        return '日'
      }
      if (week == 1) {
        return '一'
      }
      if (week == 2) {
        return '二'
      }
      if (week == 3) {
        return '三'
      }
      if (week == 4) {
        return '四'
      }
      if (week == 5) {
        return '五'
      }
      if (week == 6) {
        return '六'
      }
    },
    gomsg() {
      this.$router.push('/messageCenter')
    },
    logout() {
      localStorage.clear()
      this.$router.push('/login')
    },
    goMIne() {
      if (this.$route.path != '/mine') {
        this.$router.push('/mine')
      }
    },
    goTop() {
      // console.log('---------')
      this.$refs.aLayout.scrollIntoView({
        behavior: 'smooth', // 平滑过渡
        block: 'start' // 上边框与视窗听顶部平齐。默认值
      })
    }
  },
  watch: {
    $route() {
      // 每次更新网站标题
      // document.title = '综合业务管理-' + this.$route.meta.title
      document.title = '数字化办公系统-' + this.$route.meta.title
      //监听路由变化的时候使滚动条回到顶部  延时触发  防止不起作用
      setTimeout(() => {
        this.goTop()
      }, 50)
    }
  },
  created() {
    // 判断左侧一级菜单展开关闭
    if (this.$route.meta && this.$route.meta.isMenuOpens) {
      this.selectedOpenKeys = [this.$route.meta.isMenuOpens]
    }
    // 判断左侧对应二级菜单定位
    this.selectedKeys = [this.$route.meta.title]
  }
}
</script>
<style lang="scss">
#inlet-page {
  height: 100vh;
}
#inlet-page .trigger {
  font-size: 18px;
  line-height: 64px;
  padding: 0 24px;
  cursor: pointer;
  transition: color 0.3s;
}
.header-nav {
  display: flex;
  align-items: center;
  justify-content: space-between;
  .header-right {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    .currentDate {
      height: 21px;
      color: rgba(128, 128, 128, 1);
      font-size: 14px;
      line-height: 21px;
      margin-right: 20px;
    }
    .bell {
      width: 20px;
      height: 20px;
      font-size: 18px;
      color: rgba(80, 80, 80, 1);
      cursor: pointer;
    }
    .userInfoCont {
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      img {
        width: 24px;
        height: 24px;
        border-radius: 12px;
        margin-left: 20px;
      }
      .username {
        margin-left: 7px;
        color: rgba(0, 0, 0, 0.65);
        font-size: 14px;
      }
    }

    .header-logout {
      cursor: pointer;
      margin: 0 20px;
      // width: 56px;
      height: 22px;
      color: rgba(0, 0, 0, 0.65);
      font-size: 14px;
      line-height: 22px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      .logout-icon {
        width: 20px;
        height: 20px;
        font-size: 20px;
        color: rgba(153, 153, 153, 1);
      }
    }
  }
}
#inlet-page .trigger:hover {
  color: #1890ff;
}

#inlet-page .logo {
  height: 64px;
  background-color: rgba(2, 120, 254, 1);
  color: rgba(255, 255, 255, 1);
  font-size: 18px;
  font-weight: bold;
  line-height: 64px;
  text-align: center;
  cursor: pointer;
}
.logo-img {
  width: 80%;
}
.logo-img1 {
  height: 35px;
}
.page-menu-cont {
  height: calc(100vh - 64px);
  overflow-y: scroll;
}
// 左侧导航滚动条消失
.page-menu-cont::-webkit-scrollbar {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/views/index.vue